import Image from "@components/Image";
import Markdown from "@components/Markdown";

import cx from "classnames";
import styles from "./AllAround.module.scss";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { artPage } from "@utils/helper";

const View = () => {
  // const featured = {
  //   title: "Art All Arround",
  // };
  const { pageData } = usePageContext();
  const paragraph: any = artPage.formatParagraph(pageData);
  return (
    <section data-scroll-section className={styles.section}>
      <div className="relative flex justify-center">
        <div className={styles.headingBox}>
          <div className={cx(styles.heading)}>
            <div className={cx(styles.text)}>
              {_.get(paragraph, "title", "")}
            </div>
            <Image
              {..._.get(paragraph, "headingBackground")}
              alt={_.get(paragraph, "headingBackground.alt") || "Art all around heading background"}
              wrapperProps={{ className: cx(styles.bgImage) }}
              layout="fill"
              objectFit="cover"
              speed={0}
            />
          </div>
          <div className={cx("ama-sub-title", styles.content)}>
            <Markdown content={_.get(paragraph, "content")} />
          </div>
        </div>
        <Image
          wrapperProps={{ className: cx(styles.bg) }}
          {..._.get(paragraph, "background")}
          alt={_.get(paragraph, "background.alt") || "Art all around background"}
          layout="fill"
          speed={0}
        />
      </div>
    </section>
  );
};
export default View;
